const locale = {
	YES: 'Yes',
	NO: 'No',
	CANCEL: 'Cancel',
	LOADING: 'Loading...'
};

export default locale;
